// extracted by mini-css-extract-plugin
export var fileUpload = "_i6-1";
export var modalButton = "_i6-0";